'use client'

import Button, { ButtonColors } from 'components/ui/basic/Button'
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton
} from 'next-share'
import React, { ComponentType } from 'react'
import { Share2 } from 'react-feather'
import Overlay from './Overlay'
import { usePathname, useSearchParams } from 'next/navigation'
import { siteBaseUrl } from 'api/helpers'

const Sharing: ComponentType<{
  url?: string
  iconSize?: number
  title?: string
  label?: string
  color?: ButtonColors
  className?: string
}> = ({
  url,
  iconSize = 48,
  title = '',
  label,
  color = 'primary',
  className
}) => {
  const path = usePathname()
  const searchParams = useSearchParams()
  const urlToShare =
    url ||
    `${siteBaseUrl}${path}?${new URLSearchParams(
      searchParams ?? []
    ).toString()}`
  return (
    <Overlay
      small
      title="Teilen"
      trigger={
        <Button color={color} className={className || ''}>
          <Share2 />
          <span>{label || 'Teilen'}</span>
        </Button>
      }
    >
      <div className="text-sm text-gray-600 mb-2">
        Diesen Inhalt von Handball.net teilen auf
      </div>
      <div className="flex space-x-4 gab-4">
        <FacebookShareButton url={urlToShare} title={title}>
          <FacebookIcon size={iconSize} className="rounded" />
        </FacebookShareButton>
        <TwitterShareButton url={urlToShare} title={title}>
          <TwitterIcon size={iconSize} className="rounded" />
        </TwitterShareButton>
        <WhatsappShareButton url={urlToShare} title={title} separator=":: ">
          <WhatsappIcon size={iconSize} className="rounded" />
        </WhatsappShareButton>
        <TelegramShareButton url={urlToShare} title={title}>
          <TelegramIcon size={iconSize} className="rounded" />
        </TelegramShareButton>
        <LinkedinShareButton url={urlToShare}>
          <LinkedinIcon size={iconSize} className="rounded" />
        </LinkedinShareButton>
        <EmailShareButton url={urlToShare} subject={title} body={title}>
          <EmailIcon size={iconSize} className="rounded" />
        </EmailShareButton>
      </div>
    </Overlay>
  )
}

export default Sharing
